import type { SVGProps } from 'react';

const SvgChevronLargeIsolatedW = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M15 21.01c-.26 0-.51-.1-.71-.29l-8-8a.996.996 0 0 1 0-1.41l8-8.01a.996.996 0 1 1 1.41 1.41L8.41 12l7.29 7.29a.996.996 0 0 1-.71 1.7z"
    />
  </svg>
);
export default SvgChevronLargeIsolatedW;
